import React from "react";
import styled from "styled-components";
import { Theme } from "../../Theme";

const VIEWBOX_WIDTH = 200;
const VIEWBOX_HEIGHT = 100;
const STROKE_WIDTH = 15; // 게이지 두께
const RADIUS = 80; // 게이지 반지름 (뷰박스에 맞게 수정)
const CX = 100; // 원의 중심 X
const CY = 90; // 원의 중심 Y (뷰박스에 맞게 수정)

const TOTAL_PATH_LENGTH = Math.PI * RADIUS;

const StyledGauge = styled.svg`
    display: block;
    width: 100%;
    max-width: 300px; // 게이지의 최대 크기 (조절 가능)
    aspect-ratio: 2 / 1; // 뷰박스 비율(200x100)에 맞춰 종횡비 고정
`;

const BasePath = styled.path`
    fill: none;
    stroke-width: ${STROKE_WIDTH};
    stroke-linecap: round; // 선의 끝을 둥글게 (이미지처럼)
`;

const GaugeTrack = styled(BasePath)`
    stroke: ${(props) => props.baseColor || Theme.color.cyan500_01};
`;

const GaugeProgress = styled(BasePath)`
    stroke: ${(props) => props.barColor || Theme.color.sky800};
    stroke-dasharray: ${(props) => props.dashArray};
    transition: stroke-dasharray 0.5s ease-out; // 부드러운 애니메이션
`;

const PercentageText = styled.text`
    font-size: 30px; // 뷰박스 기준 크기
    font-weight: bold;
    fill: #222;
    text-anchor: middle; // 수평 중앙 정렬
`;

const LabelText = styled.text`
    font-size: 15px; // 뷰박스 기준 크기
    fill: #888;
    text-anchor: middle; // 수평 중앙 정렬
`;

/**
 * 게이지 차트 컴포넌트
 * @param {object} props
 * @param {number} props.percentage - 표시할 퍼센트 값 (0-100)
 * @param {string} props.label - 하단에 표시할 텍스트
 */
const CustomGaugeChart = ({ percentage, label, baseColor, barColor }) => {
    const startX = CX - RADIUS;
    const startY = CY;
    const endX = CX + RADIUS;
    const endY = CY;

    // "M (시작점) A (반지름) (각도) (플래그) (끝점)"
    const pathD = `M ${startX},${startY} A ${RADIUS},${RADIUS} 0 0 1 ${endX},${endY}`;

    // (퍼센트 / 100) * 총 길이
    const progressLength = (percentage / 100) * TOTAL_PATH_LENGTH;
    const dashArray = `${progressLength} ${TOTAL_PATH_LENGTH}`;

    return (
        <StyledGauge viewBox={`0 0 ${VIEWBOX_WIDTH} ${VIEWBOX_HEIGHT}`}>
            <GaugeTrack d={pathD} baseColor={baseColor} />

            <GaugeProgress d={pathD} dashArray={dashArray} barColor={barColor} />

            <PercentageText x="100" y="65">
                {percentage}%
            </PercentageText>
            <LabelText x="100" y="85">
                {label}
            </LabelText>
        </StyledGauge>
    );
};

export default CustomGaugeChart;
